import React from 'react';

/**
 * QuickActions - Quick action buttons panel
 * Provides quick access to common actions
 */
export const QuickActions = ({ actions = [], className = '' }) => {
  if (actions.length === 0) return null;

  return (
    <div className={`bg-white rounded-xl border border-gray-200 p-4 ${className}`}>
      <h3 className="text-sm font-semibold text-gray-700 mb-3">Quick Actions</h3>
      <div className="flex flex-wrap gap-2">
        {actions.map((action, idx) => (
          <button
            key={idx}
            onClick={action.onClick}
            className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors ${
              action.variant === 'primary'
                ? 'bg-blue-600 hover:bg-blue-700 text-white'
                : action.variant === 'danger'
                ? 'bg-red-600 hover:bg-red-700 text-white'
                : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
            }`}
          >
            {action.icon && <span className="mr-2">{action.icon}</span>}
            {action.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;
